import { Slider } from '@mui/material'
import { styled } from '@mui/material/styles';

export const StyledLoanCalculatorSlider = styled(Slider)(({ theme }) => ({
   height: '10px', // "Grubość" aktywnej części suwaka
   gridArea: 'form-slider',
   color: 'var(--main-light-color)',
   background: 'var(--main-app-color)',
   width: '100%',
   margin: '10px auto 0 auto !important',
   [theme.breakpoints.up('md')]: {
      marginTop: '25px',
   },
   '& .MuiSlider-rail': {
      background:'var(--main-app-gradient) !important',
      boxShadow: 'var(--offert-slider-rail-box-shadow) !important',
      opacity: '1 !important',
      height: '5px !important', // "Grubość" nieaktywnej części suwaka
      borderRadius: '13px !important' 
   },
   '& .MuiSlider-track:': {
      backgroundColor: 'var(--secondary-app-color) !important',
   },
   '& .MuiSlider-thumb': {
      width: '28px',
      height: '28px',
      marginLeft: 1, 
      boxShadow: 'none !important',
      '&.Mui-active': {
         boxShadow: 'var(--loan-calculator-active-thumb-box-shadow) !important'
      },
      background: 'var(--main-light-color)', //Białe tło kropki
      },
      '& .MuiSlider-thumb:after': {
         content: '""',
         display: 'block',
         width: '8px',
         height: '8px',
         boxShadow: 'none !important',
         '&.Mui-active': {
            boxShadow: 'var(--loan-calculator-active-thumb-box-shadow) !important'
         },
         border: '6px solid var(--main-app-color)',  //Obwódka wewnętrznej kropki w drugim głównym kolorze aplikacji
         background: 'var(--main-light-color)',   //Wewnętrzna biała kropka
      },
   '& .MuiSlider-mark': {
      display: 'none'
   },   
   '& .MuiSlider-markLabel': {
      color: 'var(--main-light-color)',
      marginTop: '7px',
      fontSize: '0.75rem',
      fontWeight: '400',

      '&[data-index="0"]': {
         left: '0',
         transform: 'translateX(0)'
      },
      '&[data-index="1"]': {
         left: '100% !important',
         transform: 'translateX(-100%)',
      },
   }   
}));
